import KeyContactWrapperClient, { KeyContactArticleClient } from './KeyContactWrapperClient';
export const Default = KeyContactWrapperClient;
export const KeyContactArticle = KeyContactArticleClient;
